exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box[data-v-44de234d]{\n    margin-right: 10%;\n    margin-left: 10%;\n    text-align:center;\n    border: 3px solid #35495E;\n    border-radius: 20px;\n\tpadding:16px;\n}\n.field[data-v-44de234d]{\n    padding:10px;\n    text-align:center;\n}\n.textlabel[data-v-44de234d]{\n    white-space:nowrap;\n    color:#35495E;\n}\n.textfield[data-v-44de234d]{\n    width:100%;\n}\n.title[data-v-44de234d]{\n    font-size:30px;\n    font-weight:bold;\n    color:#35495E;\n}\n.smalltext[data-v-44de234d]{\n    font-size: 12px;\n\tcolor: #888888;\n}\n.upload-box[data-v-44de234d]{\n    width:75%;\n\tz-index:3;\n}\n.custom-file-input ~ .custom-file-label[data-v-44de234d]::after {\n  content: 'sh';\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-44de234d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/edit/Edit_Inventory_Items.vue
// module id = 694
// module chunks = 0